/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createCustomFieldDataTypeSchema = z.enum(['text'])

export type CreateCustomFieldDataTypeSchema = z.infer<typeof createCustomFieldDataTypeSchema>
